import dailySchedule from "./dailySchedule.js"
import event from './event.js'
import eventPersons from './eventPersons.js'
import executedPrograms from './executedPrograms.js'
import locationProjects from "./locationProjects.js"
import partners from "./partners.js"
import previousFundedMeasures from "./previousFundedMeasures.js"
import projectDays from "./projectDays.js"
import publicFunds from "./publicFunds.js"
import furtherCosts from "./furtherCosts.js"
import equipmentCosts from "./equipmentCosts.js";

export default {
    confirmLeave: 'Möchten Sie die Seite wirklich verlassen? Alle ungespeicherten Änderungen gehen verloren.',

    requiresOrganisationProtectionConceptWarning: 'Das ausgewählte Formular erfordert ein Schutzkonzept für die Organisation. Bitte stellen Sie sicher, dass das Schutzkonzept bis zum Maßnahmenbeginn vorliegt und aktuell ist.',

    acceptNewsletterForInternationalPrograms: 'Ich interessiere mich für internationalen Jugendaustausch sowie Ferienfreizeiten und bin damit einverstanden, dass ich über aktuelle aej-Veranstaltungen und aej-Materialien zu diesen Themen per E-Mail informiert werde. Meine Zustimmung kann ich jederzeit widerrufen und die aej-Informationen über die Benutzereinstellungen abwählen.',

    organisation_id: 'Organisation',
    creator_user_id: 'Ersteller',
    process_id: 'Maßnahme',
    year_id: 'Jahr',
    bankAccount: 'Bankverbindung',
    bank_account_id: 'Bankverbindung',
    formable_id: 'Formular',
    formable_type: 'Formulartyp',
    status_id: 'Status',
    data: 'Formulardaten',
    sign: 'Unterschrift',
    projectDaysData: 'Projekttage-Daten',
    projectDaysDataProjectDays: 'Projekttage',
    projectDaysDataTotalProjectDaysDuration: 'Summe der Projekttage',
    projectDaysByHoursData: 'Projekttage nach Stunden',
    projectDaysByHoursDataProjectDays: 'Projekttage',
    projectDaysByHoursDataTotalProjectDaysDuration: 'Summe der Projekttage',
    projectDaysByHoursDataTotalProjectHoursDuration: 'Dauer der Projekttage in Stunden',

    applicant: 'Antragsteller',
    legalEntity: 'Abweichender Rechtsträger',
    contactPerson: 'Ansprechpartner',

    process: {
        intendedUseApplicant: 'Belegtext (Optional), der dem Verwendungszweck hinzugefügt wird, zur Zuordnung in ihrer Buchhaltung',
        intendedUseApplicantPlaceholder: 'Belegtext',
        intendedUseApplicantDescription: 'Maximal 25 Zeichen können angegeben werden.',
    },

    eventData: 'Maßnahmendaten',
    eventPersonData: 'Personendaten',
    publicFundsData: 'Weitere öffentliche Mittel',
    furtherCostsData: 'Weitere Kosten',
    equipmentCostsData: 'Geräte, Ausstattungs- und Ausrüstungskosten',
    previousFundedMeasuresData: 'Daten zu vorherigen geförderten Maßnahmen',
    dailyScheduleData: 'Daten zum Tagesprogramm',
    partnersData: 'Daten der ausländischen Partner',
    documentData: 'Dokumente',
    groupGermany: {
        title: 'Gruppe aus Deutschland',
        saveGroupGermany: 'Gruppe speichern'
    },

    event,
    eventPersons,
    executedPrograms,
    equipmentCosts,
    furtherCosts,
    locationProjects,
    partners,
    projectDays,
    publicFunds,
    previousFundedMeasures,
    dailySchedule,

    documents: {
        document_id: 'Dokumenten-ID',
        form_process_id: 'Formularvorgangs-ID',
        upload_box_identifier: 'Upload-Box',
        visibility_section: 'Sichtbarkeit',

        noDocuments: 'Keine Dokumente hochgeladen',
        delete: 'Löschen',
        deleteDocument: 'Dokument löschen',
        deleteDocumentText: 'Möchten Sie dieses Dokument wirklich löschen?'
    },

    confirmCreation: 'Für den Antragssteller zum Unterschreiben freigeben',
    transferAgreementsConfirmCreationAlert: 'Gebe den Weiterleitungsvertrag erst zum Unterschreiben frei, wenn alle relevanten Daten in der Maßnahme eingetragen sind.',
    finalApprovalConfirmCreation: 'Endbewilligung abschließen',
    finalApprovalConfirmCreationAlert: 'Mit dem Bestätigen wird die Endbewilligung abgeschlossen und kann danach nicht mehr bearbeitet werden.',
    confirmCreationNoStatusTransition: 'Das Formular kann in diesem Maßnahmenstatus nicht bestätigt werden.',

    signature: {
        title: 'Unterschrift',
        managementSignature: 'Unterschrift der aej',
        signature: 'Unterschrift',
        signFormProcess: 'Formular speichern und unterschreiben',
        information: 'Unterschreiben Sie das Formular erst, wenn es vollständig ausgefüllt ist und abgeschickt werden soll.',
        managementSignatureInformation: 'Unterschreiben Sie das Formular erst, wenn es vollständig ausgefüllt ist.',
        managementSignatureNoStatusTransition: 'Das Formular kann in diesem Maßnahmenstatus nicht unterschrieben werden.',
        removeSignatureWithStatusChange: 'Durch das Entfernen der Unterschrift wird der Formularstatus automatisch um einen Status zurückgesetzt.',
        errorInformation: 'Das Formular kann nicht unterschrieben werden, da es noch nicht vollständig ausgefüllt ist. Bitte wenden Sie sich an Ihren Verband.',
        unknownUser: 'Unbekannter Nutzer',
        scanQrCode: 'Scannen Sie den QR-Code, um das Formular auf Ihrem Smartphone zu unterschreiben.',
        missingScanningDevice: 'Kein Gerät zum einscannen?',
        signOnThisDevice: 'Auf diesem Gerät unterschreiben.',
        signatory: 'Unterschreibende Person',
        signTarget: 'Bereich',
        outdatedSignatureTitle: 'Unterschrift veraltet',
        outdatedSignatureText: 'Das Formular wurde nach dem Unterschreiben noch einmal bearbeitet. Bitte entfernen Sie die Unterschrift, um das Formular zu speichern. Das Formular kann jederzeit erneut unterschrieben werden.',
    },

    couldNotSendInCurrentStatus: 'Das Formular kann in diesem Maßnahmenstatus nicht abgeschickt werden. Bitte wenden Sie sich an Ihren Verband.',
    couldNotEditInCurrentStatus: 'Das Formular kann in diesem Maßnahmenstatus nicht bearbeitet werden. Bitte wenden Sie sich an Ihren Verband.',
    formReadyForSending: 'Das Formular ist bereit zum Absenden.',
    formReadyForSendingText: 'Das Formular wurde unterschrieben und kann nicht weiter bearbeitet werden.',
    removeSignature: 'Unterschrift entfernen',
    signAndSendHelpText: 'Sie können das Formular entweder direkt hier digital unterschreiben, oder Sie schicken es ab, drucken es aus, unterschreiben es und schicken es dann per Post an Ihren Verband.',
    markForSending: 'Um das Formular Absenden zu können, muss zuerst die Statistik ausgefüllt werden.<br>' +
        'Das Formular kann aber mit Klick auf "Zum Absenden vormerken und weiter zu Statistik" zum Absenden vorgemerkt' +
        'werden und sobald die Statistik abgeschickt wurde, wird automatisch auch das Formular abgeschickt.',

    formLocked: 'Das Formular ist gesperrt.',
    formLockedText: 'Das Formular wurde abgeschickt und kann nicht weiter bearbeitet werden.',

    managementArea: {
        formLocked: 'Das Formular ist gesperrt.',
        formLockedText: 'Das Formular wurde abgeschickt und kann nicht weiter bearbeitet werden.',
        formLockedInApplicationArea: 'Das Formular ist für den Antragsteller gesperrt.',
        formLockedInApplicationAreaText: 'Das Formular wurde unterschrieben und kann vom Antragsteller nicht weiter bearbeitet werden.\n\nFalls der Antragsteller das Formular noch einmal bearbeiten muss, setze die Maßnahme auf den Status "Überarbeitung" zurück.',
    },

    submit: 'Absenden',
    saveDraft: 'Entwurf speichern',
    reviewDraft: 'Zur Durchsicht freigeben',
    createSuccess: 'Das Formular wurde erfolgreich angelegt.',
    createError: 'Das Formular konnte nicht angelegt werden.',
    saveSuccess: 'Das Formular wurde erfolgreich gespeichert.',
    saveError: 'Das Formular konnte nicht gespeichert werden.',

    formNavigator: {
        newFormProcess: 'Neues Formular',
        newProcess: 'Neue Maßnahme',
        saveDraft: 'Entwurf speichern',
        reviewDraft: 'Zur Durchsicht freigeben',
        backToProcesses: 'Zurück zur Maßnahmenübersicht',
    },

    print: {
        title: 'PDF erzeugen',
        descriptionFormProcess: 'Für wen soll die PDF vom Formular {formIdentifier} erzeugt werden?',
        descriptionProcess: 'Für wen soll die PDF von der Maßnahme {vNumber} erzeugt werden?',

        printForOptions: {
            applicant: 'Zuschussbeantragende',
            manager: 'Zuschussverwaltende',
            donor: 'Zuschussgebende'
        },

        printSuccess: 'Die PDF wurde erfolgreich erzeugt.',
        printError: 'Die PDF konnte nicht erzeugt werden.'
    },

    transferAgreements: {
        transferAgreementDescription: 'Der Weiterleitungsvertrag berechtigt die aej dazu, Daten zwischen dem Zuwendungsgeber und dem Zuwendungsempfänger auszutauschen. ' +
            'Bitte laden Sie den Vertrag herunter und lesen Sie ihn sorgfältig durch.',
        signatureInformation: 'Sie können entweder ein Bild Ihrer Unterschrift hochladen, den Vertrag ausdrucken, unterschreiben und wieder hochladen oder den Vertrag digital unterschreiben.',
    },

    success: {
        successfullySentTypes: {
            request: 'Ihr Antrag wurde erfolgreich abgesendet!',
            proof: 'Ihr Verwendungsnachweis wurde erfolgreich abgesendet!',
            goal_agreement: 'Ihre Zielvereinbarung wurde erfolgreich abgesendet!',
            transfer_agreement: 'Ihr Weiterleitungsvertrag wurde erfolgreich abgesendet!',
            goal_achievement: 'Ihre Auswertung wurde erfolgreich abgesendet!'
        },
    },

    deleteFormProcess: 'Formular löschen',
    deleteFormProcessText: 'Möchten Sie dieses Formular wirklich löschen?',
    deleteFormProcessTextLastForm: 'Die Maßnahme wird bei dieser Aktion ebenfalls gelöscht.',
    deleteFormProcessSuccess: 'Formular wurde erfolgreich gelöscht.',
    deleteFormProcessError: 'Das Formular konnte nicht gelöscht werden.'
}